export default __webpack_public_path__ + "static/media/q7_01.5099a27b.jpg";